import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id1 = uuid();
    const id2 = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id1})`}>
                <g clipPath={`url(#${id2})`}>
                    <rect width='24' height='24' rx='4' fill='#9D9BA7' />
                    <rect x='2.92383' y='6.44568' width='19.546' height='13.5972' fill='white' />
                    <path
                        d='M24.3286 3.23728L16.5846 -4.51025C16.3687 -4.72616 16.0736 -4.84851 15.7678 -4.84851H0.485011C-0.151921 -4.84851 -0.666504 -4.33393 -0.666504 -3.697V26.2424C-0.666504 26.8793 -0.151921 27.3939 0.485011 27.3939H23.5153C24.1522 27.3939 24.6668 26.8793 24.6668 26.2424V4.05054C24.6668 3.74467 24.5445 3.45319 24.3286 3.23728ZM7.96986 7.31437C8.76512 7.31437 9.40925 7.9585 9.40925 8.75376C9.40925 9.54903 8.76512 10.1932 7.96986 10.1932C7.17459 10.1932 6.53047 9.54903 6.53047 8.75376C6.53047 7.9585 7.17459 7.31437 7.96986 7.31437ZM18.6214 17.8939H5.37895C5.13785 17.8939 5.00471 17.6168 5.15225 17.4297L8.74353 12.8524C8.77046 12.818 8.80487 12.7902 8.84415 12.7711C8.88343 12.7519 8.92655 12.742 8.97024 12.742C9.01393 12.742 9.05705 12.7519 9.09633 12.7711C9.13561 12.7902 9.17001 12.818 9.19694 12.8524L10.6759 14.738L13.4755 11.1683C13.5025 11.1339 13.5369 11.1061 13.5762 11.087C13.6154 11.0678 13.6586 11.0579 13.7022 11.0579C13.7459 11.0579 13.7891 11.0678 13.8283 11.087C13.8676 11.1061 13.902 11.1339 13.9289 11.1683L18.8409 17.4297C18.9956 17.6168 18.8589 17.8939 18.6214 17.8939ZM15.2388 4.57952V-2.19283L22.0111 4.57952H15.2388Z'
                        fill='#9D9BA7'
                    />
                </g>
            </g>
            <defs>
                <clipPath id={id1}>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
                <clipPath id={id2}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
